import React, { useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Label,
  FormGroup,
  Form,
  Alert,
  Input,

  InputGroupText,
  InputGroup,
  Container,
  Col,
  Row
} from "reactstrap";
import cookie from 'react-cookies'
import { connect, useSelector, useDispatch } from 'react-redux';
import { Helmet } from "react-helmet";
import "components/custom.css";
import API from "api.js";
import { Navigate, NavLink, Link } from "react-router-dom";
import { setToken, setUser, setSub, setAlert, setLoader } from 'action/index.js';
import LaLoader from "components/Loader/LaLoader.jsx";


const Forgot = (props) => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error_bag, setErrorBag] = useState(null);
  const [otpflag, setOtpflag] = useState(false);

  // useEffect(() => {
  //   document.body.classList.toggle("login-page");
  //   return () => {
  //     document.body.classList.toggle("login-page");
  //   };
  // }, []);

  const postLogIn = async (e) => {
    if(loading){
      return;
    }
    setLoading(true);
    setErrorBag(null);
    e.preventDefault();
    dispatch(setLoader(false));
    
    var bodyFormData = new FormData();
    bodyFormData.set('email', email);
    let res = null;
    try {
      res = await API({
        method: 'POST',
        url: '/forgot',
        data: bodyFormData,
      })
      if (res.status === 200) {
        setOtpflag(true);
        setErrorBag("Verification code sent to your Email !");
        setLoading(false);
        return
      }
    } catch (error) {
      const resp = error?.response;
      dispatch(
        setAlert({
          flag: true,
          type: 2,
          message: `${resp?.data?.message || "Something went wrong. Please try again."}`,
        })
      );
       setLoading(false);
      return;
    }


  }

  const changeInput = (e) => {
    let { name, value } = e.target;
    if (name === 'email') {
      setEmail(value);
    } else if (name === 'password') {
      setPassword(value);
    }
  };

  
  return (
    <React.Fragment>
      <LaLoader show={loading} />
      <Helmet>
        <title>Language Academy Password Recovery | Reset Your Password</title>
        <meta
          name="description"
          content="Forgot your Language Academy password? Reset it quickly and easily to regain access to your account and continue your learning."
        />
      </Helmet>

      <div className="innerPage">
        <div className="form-page-wrapper account-wrapper login-content mt-80">
          <div className="form-header">
            <div className="container">
              <div>
                <h2 className="primary-heading text-center">Forgot <span className="wpl-badge pte-naati-badge text-white">Password</span></h2>
                <div className="form-content-outer position-relative">
                  {/* <img
                      className="emoji-img1"
                      src="/images/web-new-images/emojis/33.png"
                      alt="LA"
                    />
                    <img
                      className="emoji-img2"
                      src="/images/web-new-images/emojis/rocket-icon2.png"
                      alt="LA"
                    /> */}
                  <div className="form-content">
                    <div className="form-img">
                      <img
                        className="img-fluid"
                        src="/images/web-new-images/hero_img1.png"
                        alt="LA"
                      />
                    </div>
                    <div className="loginForm">
                      {error_bag && <Alert color="warning">{error_bag}</Alert>}
                      <div className="fieldOuter">
                        <label htmlFor="email">Email*</label>
                        <div className="form-input-outer">
                          <input
                            id="email"
                            className="form-input"
                            placeholder="Enter Email"
                            type="text"
                            name="email"
                            value={email}
                            onChange={(e) => { changeInput(e) }}
                          />
                        </div>
                      </div>
                      <div className="rememberForgot d-flex justify-content-end mx-2">
                        {/* <div className="rememberMe">
                                <div className="form-check">
                                  <input className="form-check-input" type="checkbox" name="flexRadioDefault" id="flexRadioDefault1" />
                                  <label className="form-check-label" for="flexRadioDefault1">
                                  Remember me
                                  </label>
                                </div>
                              </div> */}
                        <div className="forgotPwd">
                          <NavLink className="mt-5" to='/auth/login'><span>Back</span></NavLink>
                        </div>
                      </div>
                      <div className="fieldOuter">
                        <button
                          className="themeBtn primary-btn"
                          onClick={(e) => { postLogIn(e) }}
                        >
                          Submit <img src="/images/web-new-images/right-arrow.svg" alt="LA" />
                        </button>
                        {otpflag && <NavLink to="/auth/resetPassword">Got verification code?</NavLink>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="rl-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="rl-content">
                  <div className="rl-outer">
                    <div className="rl-card">
                      <div>
                        <h3 className="rl-title">Get our portal for your institute</h3>
                        <p className="normal-text">Have institute? Need portal for students?</p>
                      </div>
                      <Link to="/auth/login" className="outline-btn">REQUEST NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" />
                      </Link>
                    </div>
                  </div>
                  <div className="rl-outer">
                    <div className="rl-card">
                      <h3 className="rl-title">Login to NAATI CCL Portal</h3>
                      <a href="https://www.laccl.languageacademy.com.au/auth/login" className="outline-btn">LOG IN <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></a>
                    </div>
                  </div>
                  <div className="rl-outer">
                    <div className="rl-card login-new-user">
                      <div>
                        <h3 className="rl-title">NEW USER?</h3>
                        <p className="normal-text">Register now to obtain your Free Mock Test Material</p>
                      </div>
                      <Link to="/auth/register" className="primary-btn">Register NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Forgot;
